import React from "react"

export const EcosystemIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.01"
        d="M18.5192 0H1.48077C0.662963 0 0 0.662963 0 1.48077V18.5192C0 19.337 0.662963 20 1.48077 20H18.5192C19.337 20 20 19.337 20 18.5192V1.48077C20 0.662963 19.337 0 18.5192 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.38462 13.2308C6.14932 13.2308 6.76923 13.8507 6.76923 14.6154C6.76923 15.3801 6.14932 16 5.38462 16C4.61991 16 4 15.3801 4 14.6154C4 13.8507 4.61991 13.2308 5.38462 13.2308ZM10 13.2308C10.7647 13.2308 11.3846 13.8507 11.3846 14.6154C11.3846 15.3801 10.7647 16 10 16C9.2353 16 8.61539 15.3801 8.61539 14.6154C8.61539 13.8507 9.2353 13.2308 10 13.2308ZM14.6154 13.2308C15.3801 13.2308 16 13.8507 16 14.6154C16 15.3801 15.3801 16 14.6154 16C13.8507 16 13.2308 15.3801 13.2308 14.6154C13.2308 13.8507 13.8507 13.2308 14.6154 13.2308ZM5.38462 8.61539C6.14932 8.61539 6.76923 9.2353 6.76923 10C6.76923 10.7647 6.14932 11.3846 5.38462 11.3846C4.61991 11.3846 4 10.7647 4 10C4 9.2353 4.61991 8.61539 5.38462 8.61539ZM10 8.61539C10.7647 8.61539 11.3846 9.2353 11.3846 10C11.3846 10.7647 10.7647 11.3846 10 11.3846C9.2353 11.3846 8.61539 10.7647 8.61539 10C8.61539 9.2353 9.2353 8.61539 10 8.61539ZM14.6154 8.61539C15.3801 8.61539 16 9.2353 16 10C16 10.7647 15.3801 11.3846 14.6154 11.3846C13.8507 11.3846 13.2308 10.7647 13.2308 10C13.2308 9.2353 13.8507 8.61539 14.6154 8.61539ZM5.38462 4C6.14932 4 6.76923 4.61991 6.76923 5.38462C6.76923 6.14932 6.14932 6.76923 5.38462 6.76923C4.61991 6.76923 4 6.14932 4 5.38462C4 4.61991 4.61991 4 5.38462 4ZM10 4C10.7647 4 11.3846 4.61991 11.3846 5.38462C11.3846 6.14932 10.7647 6.76923 10 6.76923C9.2353 6.76923 8.61539 6.14932 8.61539 5.38462C8.61539 4.61991 9.2353 4 10 4ZM14.6154 4C15.3801 4 16 4.61991 16 5.38462C16 6.14932 15.3801 6.76923 14.6154 6.76923C13.8507 6.76923 13.2308 6.14932 13.2308 5.38462C13.2308 4.61991 13.8507 4 14.6154 4Z"
        fill="url(#paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.38462 13.2308C6.14932 13.2308 6.76923 13.8507 6.76923 14.6154C6.76923 15.3801 6.14932 16 5.38462 16C4.61991 16 4 15.3801 4 14.6154C4 13.8507 4.61991 13.2308 5.38462 13.2308ZM14.6154 13.2308C15.3801 13.2308 16 13.8507 16 14.6154C16 15.3801 15.3801 16 14.6154 16C13.8507 16 13.2308 15.3801 13.2308 14.6154C13.2308 13.8507 13.8507 13.2308 14.6154 13.2308ZM10 8.61539C10.7647 8.61539 11.3846 9.2353 11.3846 10C11.3846 10.7647 10.7647 11.3846 10 11.3846C9.2353 11.3846 8.61539 10.7647 8.61539 10C8.61539 9.2353 9.2353 8.61539 10 8.61539ZM5.38462 4C6.14932 4 6.76923 4.61991 6.76923 5.38462C6.76923 6.14932 6.14932 6.76923 5.38462 6.76923C4.61991 6.76923 4 6.14932 4 5.38462C4 4.61991 4.61991 4 5.38462 4ZM14.6154 4C15.3801 4 16 4.61991 16 5.38462C16 6.14932 15.3801 6.76923 14.6154 6.76923C13.8507 6.76923 13.2308 6.14932 13.2308 5.38462C13.2308 4.61991 13.8507 4 14.6154 4Z"
        fill="#CED1D5"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="16"
          y1="4.61946"
          x2="5.10914"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#08A1ED" />
          <stop offset="0.549439" stopColor="#31B54E" />
          <stop offset="1" stopColor="#A3CD39" />
        </linearGradient>
      </defs>
    </svg>
  )
}
